import * as React from 'react';
import useLabelTranslation from 'src/hooks/useLabelTranslation';
import startCase from 'lodash/startCase';

import {FilterCard} from './';
import Checkbox from 'src/components/lib/checkbox/index';

import css from './recipient-card.css';


type Props = {
  onSave?: (e: React.SyntheticEvent) => unknown;
  onCancel?: (e: React.SyntheticEvent) => unknown;
  onTrackingEventTypeChange: (
    e: React.SyntheticEvent<HTMLInputElement>,
  ) => unknown;
  trackingEventTypes: string[];
  selectedTrackingEventTypes: string[];
};

const TrackingEventCard = ({
  onSave,
  onCancel,
  onTrackingEventTypeChange,
  trackingEventTypes = [],
  selectedTrackingEventTypes = [],
}: Props) => {
  const {t} = useLabelTranslation();
  return (
    <FilterCard
      header={t('Marketing', 'Marketing')}
      onSave={onSave}
      onCancel={onCancel}
    >
      <section className={css.section}>
        <ul className={css.checklist}>
          {trackingEventTypes.map((value) => (
            <li key={value}>
              <label className={css.label}>
                <Checkbox
                  className={css.checkbox}
                  name={value}
                  checked={selectedTrackingEventTypes.includes(value)}
                  onChange={onTrackingEventTypeChange}
                />
                {startCase(value)}
              </label>
            </li>
          ))}
        </ul>
      </section>
    </FilterCard>
  );
};

export default TrackingEventCard;
